import { API, Helpers, Router } from '../Helpers';
import { Checkbox, Radio, RadioGroup } from 'react-icheck';
import FroalaEditor from 'react-froala-wysiwyg';
import { InputHidden, InputText, TextArea } from '../Core';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactSortable } from "react-sortablejs";

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            destination_loader_content: this.findDestinationLoaderContent(),
            destination_menu: this.findDestinationMenu(),
            menu_items: this.defaultMenuItems(),
            selected_pages: []
        };
        
        this.addCustomLinkToMenu = this.addCustomLinkToMenu.bind(this);
        this.addPagesToMenu = this.addPagesToMenu.bind(this);
        this.clearSelectedPages = this.clearSelectedPages.bind(this);
        this.defaultMenuItems = this.defaultMenuItems.bind(this);
        this.findDestinationLoaderContent = this.findDestinationLoaderContent.bind(this);
        this.findDestinationMenu = this.findDestinationMenu.bind(this);
        this.findDestinationMenuBackground = this.findDestinationMenuBackground.bind(this);
        this.findSidenavBackground = this.findSidenavBackground.bind(this);
        this.removeFromMenu = this.removeFromMenu.bind(this);
        this.selectPage = this.selectPage.bind(this);
        this.setDestinationLoaderContent = this.setDestinationLoaderContent.bind(this);
        this.setDestinationMenu = this.setDestinationMenu.bind(this);
        this.setMenuItems = this.setMenuItems.bind(this);
        this.toggleSelectPage = this.toggleSelectPage.bind(this);
        this.unselectPage = this.unselectPage.bind(this);
        this.updateMenuItem = this.updateMenuItem.bind(this);
    }
    
    addCustomLinkToMenu(event)
    {
        event.preventDefault();
        
        //console.log("addCustomLinkToMenu");
        
        const form = event.target;
        const formData = new FormData(form);
        
        let menu_items = [...this.state.menu_items];
        let menu_item = Helpers.serializeFormData(formData);
        
        menu_item.id = uniqid();
        menu_item.type = 'custom';
        
        menu_items.push(menu_item);
        
        this.setMenuItems(menu_items);
    }
    
    addPagesToMenu()
    {
        //console.log("addPagesToMenu");
        
        const router = Router(this.props.data.routes);
        
        let menu_items = [...this.state.menu_items];
        
        //console.log('menu_items', menu_items);
        //console.log(_.uniqueId());
        
        _.forEach(this.state.selected_pages, (page) => {
            
            menu_items.push({
                id: uniqid(),
                url: router.url('customer.pages.show', {domain: this.props.data.active_site.domain, page: page.slug}),
                navigation_label: page.title,
                type: 'page'
            });
        });
        
        this.setMenuItems(menu_items, true);
    }
    
    clearSelectedPages()
    {
        this.setState({
            selected_pages: []
        });
    }
    
    defaultMenuItems()
    {
        let menu_items = _.find(this.props.data.active_site.settings.data, (_setting) => { return _setting.key == 'menu_items'; });
        
        //console.log('menu_items', menu_items)
        
        if (!_.isEmpty(menu_items))
        {
            return JSON.parse(menu_items.value);
        }
        
        return [];
    }
    
    findDestinationLoaderContent()
    {
        let destination_loader_content = _.find(this.props.data.active_site.settings.data, (setting) => { return setting.key == 'destination_loader_content'; });
        
        //console.log("destination_loader_content", destination_loader_content);
        
        if (!_.isEmpty(destination_loader_content))
        {
            return destination_loader_content.value;
        }
    }
    
    findDestinationMenu()
    {
        let destination_menu = _.find(this.props.data.active_site.settings.data, (setting) => { return setting.key == 'destination_menu'; });
        
        if (!_.isEmpty(destination_menu))
        {
            return destination_menu.value;
        }
        
        return 1;
    }
    
    findDestinationMenuBackground()
    {
        let destination_menu_background = _.find(this.props.data.active_site.settings.data, (setting) => { return setting.key == 'destination_menu_background'; });
        
        if (!_.isEmpty(destination_menu_background))
        {
            return destination_menu_background.value;
        }
    }
    
    findSidenavBackground()
    {
        let sidenav_background = _.find(this.props.data.active_site.settings.data, (setting) => { return setting.key == 'sidenav_background'; });
        
        if (!_.isEmpty(sidenav_background))
        {
            return sidenav_background.value;
        }
    }
    
    removeFromMenu(index)
    {
        //console.log("removeFromMenu", index);
        
        let menu_items = [...this.state.menu_items];
        
        menu_items = _.filter(menu_items, (menu_item, _index) => { return _index !== index; });
        
        this.setMenuItems(menu_items);
    }
    
    selectPage(page)
    {
        let selected_pages = [...this.state.selected_pages];
        
        this.setState({ 
            selected_pages: selected_pages.concat([page])
        }, () => 
        {
            //console.log("this.state.selected_pages", this.state.selected_pages);
        });
    }
    
    setDestinationLoaderContent(destination_loader_content)
    {
        //console.log("setDestinationLoaderContent", destination_loader_content);
        
        this.setState({
            destination_loader_content: destination_loader_content
        });
    }
    
    setMenuItems(newState, clearSelectedPages)
    {
        // console.log(newState);
        
        this.setState({ 
            menu_items: newState 
        }, () => 
        {
            if (clearSelectedPages)
            {
                this.clearSelectedPages();
            }
        });
    }
    
    toggleSelectPage(page, event)
    {
        //console.log("toggleSelectPage", page, event.target.checked);
        
        if (event.target.checked)
        {
            this.selectPage(page);
        }
        else
        {
            this.unselectPage(page);
        }
    }
    
    unselectPage(page)
    {
        //console.log("unselectPage", page);
        
        let selected_pages = this.state.selected_pages.filter((_page) =>
            {
                return _page.id !== page.id;
            });
        
        this.setState({ 
            selected_pages: selected_pages
        }, () => 
        {
            //console.log("this.state.selected_pages", this.state.selected_pages);
        });
    }
    
    setDestinationMenu(event)
    {
        //console.log("setDestinationMenu");
        
        //console.log(index);
        //console.log(event.target);
        //console.log(event.target.value);
        //console.log(event.target.name);
        
        this.setState({
            destination_menu: event.target.value
        });
    }
    
    updateMenuItem(index, event)
    {
        //console.log("updateMenuItem");
        
        let menu_items = [...this.state.menu_items]
        let menu_item = _.nth(menu_items, index);
        
        if (event.target.type == 'checkbox')
        {
            menu_item[event.target.name] = event.target.checked;
        }
        else
        {
            menu_item[event.target.name] = event.target.value;
        }
        
        //console.log(index);
        //console.log(event.target);
        //console.log(event.target.value);
        //console.log(event.target.name);
        
        //console.log(menu_item);
        
        menu_items.splice(index, 1, menu_item);
        
        this.setMenuItems(menu_items);
    }
        
    render() {
        
        const { active_site, csrf_token, env, pages, redirect_to, routes } = this.props.data;
        const router = Router(routes);
        const destination_menu_background = this.findDestinationMenuBackground();
        const sidenav_background = this.findSidenavBackground();
        
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <h3>Menu Editor</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <div className="card border mb-3">
                            <div className="card-header">
                                Pages
                            </div>
                            <div className="card-body overflow-y-scroll" style={{ maxHeight: '200px' }}>
                                <ul className="list-unstyled">
                                    {
                                        pages.data.map((page, key) => {

                                            return (
                                                <li key={key}>
                                                    <div className="custom-control custom-checkbox">
                                                        <input 
                                                            type="checkbox" 
                                                            className="custom-control-input" 
                                                            id={"page_" + key} 
                                                            onChange={(event) => {this.toggleSelectPage(page, event)}}
                                                            checked={_.findIndex(this.state.selected_pages, (_page) => { return _page.id == page.id; }) > -1}
                                                        />
                                                        <label className="custom-control-label" htmlFor={"page_" + key}>{page.title}</label>
                                                    </div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="card-footer border-top-0">
                                <div className="float-right">
                                    <button 
                                        className="btn btn-primary" 
                                        type="submit"
                                        disabled={_.isEmpty(this.state.selected_pages)}
                                        onClick={this.addPagesToMenu}>
                                        Add to menu
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <form onSubmit={this.addCustomLinkToMenu}>
                            <div className="card border">
                                <div className="card-header">
                                    Custom Link
                                </div>
                                <div className="card-body overflow-y-scroll" style={{ maxHeight: '300px' }}>
                                    <div className="form-group row">
                                        <div className="col-12">
                                            <InputText name="url" label="URL" />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-12">
                                            <InputText name="navigation_label" label="Navigation label" />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group form-row row">
                                        <div className="col-12">
                                            <InputText name="icon" label="Icon" />
                                        </div>
                                    </div>

                                    <div className="form-group form-row row">
                                        <div className="col-12">
                                            <InputText name="css_id" label="CSS ID (optional)" />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group form-row row">
                                        <div className="col-12">
                                            <InputText name="css_class" label="CSS Classes (optional)" />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group form-row row">
                                        <div className="col-12">
                                            <TextArea 
                                                name="data_attributes" 
                                                label="Data attributes (comma separated)"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-12">
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" name="open_in_new_tab" value="1" className="custom-control-input" id="openInNewTab" />
                                                <label className="custom-control-label" htmlFor="openInNewTab">Open in new tab</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer border-top-0">
                                    <div className="float-right">
                                        <button className="btn btn-primary"  type="submit">
                                            Add to menu
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-8">
                        <div className="card border">
                            <div className="card-header">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>Menu</div>
                                    <div>
                                        <form action={router.url('admin.settings.store')} method="POST" encType="multipart/form-data" accept-charset="UTF-">
                                            <InputHidden name="_token" defaultValue={csrf_token} />
                                            <InputHidden name="site_id" defaultValue={active_site.id} />
                                            <InputHidden name="redirect_to" defaultValue={redirect_to} />
                                            <input type="hidden" name="destination_menu" value={this.state.destination_menu} readOnly={true} />

                                            <div className="d-none">
                                                <textarea name="menu_items" value={JSON.stringify(this.state.menu_items)} readOnly={true} />
                                            </div>
                                            
                                            <div className="d-none">
                                                <textarea 
                                                    name="destination_loader_content" 
                                                    value={this.state.destination_loader_content}
                                                    readOnly={true}
                                                />
                                            </div>
                                            
                                            <button 
                                                className="btn btn-primary"
                                                type="submit"
                                                disabled={_.isEmpty(this.state.menu_items)}>
                                                Save changes
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {
                                    _.isEmpty(this.state.menu_items) ?
                                    <div>
                                        <div className="row mb-4">
                                            <div className="col-12">
                                                <h4>Menu Structure</h4>
                                                <div>To get started, add menu items from the column on the left.</div>
                                            </div>
                                        </div>
                                    </div> :
                                    <div>
                                        <div className="row mb-4">
                                            <div className="col-12">
                                                <h4>Menu Structure</h4>
                                                <div>Drag each item into the order you prefer. Click the arrow to the right of each item to reveal additional configuration options.</div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-8">
                                                <ReactSortable
                                                    list={this.state.menu_items}
                                                    setList={(newState) => this.setMenuItems(newState)}
                                                >
                                                    {
                                                        this.state.menu_items.map((menu_item, key) => {

                                                            return (
                                                                <div key={menu_item.id} className="mb-2">
                                                                    <div 
                                                                        className="list-group-item px-2 d-flex justify-content-between rounded-0">
                                                                        <div>
                                                                            <div className="media">
                                                                                <div className="align-self-center mr-2">
                                                                                    <button 
                                                                                        className="btn btn-flat"
                                                                                        onClick={() => this.removeFromMenu(key)}
                                                                                    >
                                                                                        <i className="fa fa-times"></i>
                                                                                    </button>
                                                                                </div>
                                                                                <div className="media-body align-self-center">
                                                                                    <div className="font-weight-bold">{menu_item.navigation_label}</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <a className="btn btn-flat" data-toggle="collapse" href={"#collapseMenuItem_" + key} role="button">
                                                                                <i className="fa fa-angle-down"></i>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                    <div className="collapse" id={"collapseMenuItem_" + key}>
                                                                        <div className="card border rounded-0">
                                                                            <div className="card-body">
                                                                                <div className="form-group row">
                                                                                    <div className="col-12">
                                                                                        <InputText 
                                                                                            name="url" 
                                                                                            label="URL" 
                                                                                            defaultValue={menu_item.url} 
                                                                                            onChange={(event) => {this.updateMenuItem(key, event)}}
                                                                                            disabled={menu_item.type == 'page'}
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <div className="form-group row">
                                                                                    <div className="col-12">
                                                                                        <InputText 
                                                                                            name="navigation_label" 
                                                                                            label="Navigation label" 
                                                                                            defaultValue={menu_item.navigation_label} 
                                                                                            onChange={(event) => {this.updateMenuItem(key, event)}} 
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                
                                                                                <div className="form-group form-row row">
                                                                                    <div className="col-12">
                                                                                        <InputText 
                                                                                            name="icon" 
                                                                                            label="Icon" 
                                                                                            defaultValue={menu_item.icon} 
                                                                                            onChange={(event) => {this.updateMenuItem(key, event)}} 
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <div className="form-group form-row row">
                                                                                    <div className="col-12">
                                                                                        <InputText 
                                                                                            name="css_id" 
                                                                                            label="CSS ID (optional)" 
                                                                                            defaultValue={menu_item.css_id} 
                                                                                            onChange={(event) => {this.updateMenuItem(key, event)}} 
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group form-row row">
                                                                                    <div className="col-12">
                                                                                        <InputText 
                                                                                            name="css_class" 
                                                                                            label="CSS Classes (optional)" 
                                                                                            defaultValue={menu_item.css_class} 
                                                                                            onChange={(event) => {this.updateMenuItem(key, event)}} 
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                
                                                                                <div className="form-group form-row row">
                                                                                    <div className="col-12">
                                                                                        <TextArea 
                                                                                            name="data_attributes" 
                                                                                            label="Data attributes (comma separated)" 
                                                                                            defaultValue={menu_item.data_attributes} 
                                                                                            onChange={(event) => {this.updateMenuItem(key, event)}} 
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <div className="form-group row mb-0">
                                                                                    <div className="col-12">
                                                                                        <div className="custom-control custom-checkbox">
                                                                                            <input 
                                                                                                type="checkbox" 
                                                                                                name="open_in_new_tab" 
                                                                                                value="1" 
                                                                                                className="custom-control-input" 
                                                                                                id={"openInNewTab_" + key} 
                                                                                                defaultChecked={menu_item.open_in_new_tab} 
                                                                                                onChange={(event) => {this.updateMenuItem(key, event)}} 
                                                                                            />
                                                                                            <label className="custom-control-label" htmlFor={"openInNewTab_" + key}>Open in new tab</label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </ReactSortable>
                                            </div>
                                        </div>
                                    </div>
                                }
                                
                                <hr className="my-5" />
                                    
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <h4>Destination Menu</h4>
                                        <div>Choose a layout to use for the destination menu</div>
                                    </div>
                                </div>

                                <div className="row mb-4">
                                    <div className="col-6">
                                        <div className="card border">
                                            <div className="card-body">
                                                <div className="custom-control custom-radio mb-3">
                                                    <input 
                                                        name="destination_menu"
                                                        type="radio" 
                                                        value="1" 
                                                        className="custom-control-input" 
                                                        id="destinationMenu1" 
                                                        onChange={(event) => {this.setDestinationMenu(event)}} 
                                                        checked={this.state.destination_menu == 1}
                                                    />
                                                    <label className="custom-control-label" htmlFor="destinationMenu1">Destination Menu 1</label>
                                                </div>

                                                <div>
                                                    <img className="img-fluid" src="/images/DestinationMenu1.jpg" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-6">
                                        <div className="card border">
                                            <div className="card-body">
                                                <div className="custom-control custom-radio mb-3">
                                                    <input 
                                                        name="destination_menu"
                                                        type="radio" 
                                                        value="2" 
                                                        className="custom-control-input" 
                                                        id="destinationMenu2" 
                                                        onChange={(event) => {this.setDestinationMenu(event)}} 
                                                        checked={this.state.destination_menu == 2}
                                                    />
                                                    <label className="custom-control-label" htmlFor="destinationMenu2">Destination Menu 2</label>
                                                </div>

                                                <div>
                                                    <img className="img-fluid" src="/images/DestinationMenu2.jpg" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row">
                                    <div className="col-12">
                                        <form action={router.url('admin.settings.store')} method="POST" encType="multipart/form-data" accept-charset="UTF-">
                                            <InputHidden name="_token" defaultValue={csrf_token} />
                                            <InputHidden name="site_id" defaultValue={active_site.id} />
                                            <InputHidden name="redirect_to" defaultValue={redirect_to} />
                                        
                                            {
                                                !_.isEmpty(destination_menu_background) &&
                                                <div className="card border mb-2">
                                                    <div className="card-body">
                                                        <div className="mb-3">
                                                            <img className="img-fluid" src={destination_menu_background} />
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            <label>Destination Menu Background</label>
                                            <div className="custom-file mb-3">
                                                <input type="file" name="destination_menu_background" className="custom-file-input" id="destination_menu_background" />
                                                <label className="custom-file-label" for="destination_menu_background">Choose file</label>
                                            </div>
                                            
                                            <button className="btn btn-primary mb-5" type="submit">Upload</button>
                                            
                                            {
                                                !_.isEmpty(sidenav_background) &&
                                                <div className="card border mb-2">
                                                    <div className="card-body">
                                                        <div className="mb-3">
                                                            <img className="img-fluid" src={sidenav_background} />
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            <label>Sidenav Background</label>
                                            <div className="custom-file mb-3">
                                                <input type="file" name="sidenav_background" className="custom-file-input" id="sidenav_background" />
                                                <label className="custom-file-label" for="sidenav_background">Choose file</label>
                                            </div>
                                            
                                            <button className="btn btn-primary" type="submit">Upload</button>
                                        </form>
                                    </div>
                                </div>
                                
                                <hr className="my-5" />
                                
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <h4>Destination Loader</h4>
                                        <div>Edit the content you want to show on the loading screen when a user chooses a destination</div>
                                    </div>
                                </div>
                                
                                <FroalaEditor
                                    config={{
                                        charCounterCount: true,
                                        enter: FroalaEditor.ENTER_BR,
                                        heightMin: 200,
                                    }}
                                    model={this.state.destination_loader_content}
                                    onModelChange={(event) => {this.setDestinationLoaderContent(event)}} 
                                />
                            </div>
                            <div className="card-footer border-top-0">
                                <div className="float-right">
                                    <form action={router.url('admin.settings.store')} method="POST">
                                        <InputHidden name="_token" defaultValue={csrf_token} />
                                        <InputHidden name="site_id" defaultValue={active_site.id} />
                                        <InputHidden name="redirect_to" defaultValue={redirect_to} />
                                        <input type="hidden" name="destination_menu" value={this.state.destination_menu} readOnly={true} />

                                        <div className="d-none">
                                            <textarea name="menu_items" value={JSON.stringify(this.state.menu_items)} readOnly={true} />
                                        </div>
                                        
                                        <div className="d-none">
                                            <textarea 
                                                name="destination_loader_content" 
                                                value={this.state.destination_loader_content}
                                                readOnly={true}
                                            />
                                        </div>
                                        
                                        <button 
                                            className="btn btn-primary"
                                            type="submit"
                                            disabled={_.isEmpty(this.state.menu_items)}>
                                            Save changes
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('menuEditor')) {
    
    const element = document.getElementById('menuEditor');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);
    
    ReactDOM.render(<App data={JSON.parse(data.data)} />, document.getElementById('menuEditor'));
}



// WEBPACK FOOTER //
// ./resources/js/components/MenuEditor/App.js